import { __rest } from "tslib";
import React from 'react';
import { default as useGetLabels } from "@pb/utils/labels/useGetLabels";
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import HeadingLoader from "../../helpers/Loaders/HeadingLoader";
import Markup from "../../helpers/Markup";
const Label = (_a) => {
    var { copyKey = '', replacements, shouldSanitize = true, className, customReplacementFunction } = _a, props = __rest(_a, ["copyKey", "replacements", "shouldSanitize", "className", "customReplacementFunction"]);
    const { showLabelKeys, isFetchingLabels } = useGetLabels();
    if (showLabelKeys) {
        return React.createElement(React.Fragment, null, copyKey);
    }
    if (isFetchingLabels) {
        return React.createElement(HeadingLoader, { marginless: true, small: true });
    }
    const label = getLabelFromStorage(copyKey, { replacements });
    return customReplacementFunction ? (React.createElement(React.Fragment, null, customReplacementFunction(label))) : (React.createElement(Markup, Object.assign({ className: className, input: label, sanitized: shouldSanitize }, props)));
};
export default Label;
//# sourceMappingURL=Label.js.map